module.exports = __webpack_public_path__ + "25-o1.jpg?544a69d262ccf6de64e5c0f1aa535f71";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/25-o1.jpg
// module id = 650
// module chunks = 0